import { cawsContractAbi } from './abis'
import Web3 from 'web3'

const cawsContractAddress = '0xd06cF9e1189FEAb09c844C597abc3767BC12608c'

export const web3 = new Web3()
web3.setProvider(window.ethereum)

export const cawsContractWeb3 = new Web3()
cawsContractWeb3.setProvider(window.ethereum)
export const cawsContract = new cawsContractWeb3.eth.Contract(cawsContractAbi, cawsContractAddress)
